export function fixedSidebar() {
    const SideBar = document.getElementById("allSidebar")
    SideBar?.style.setProperty('position', 'fixed')
}

export function defaultSidebar() {
    const SideBar = document.getElementById("allSidebar")
    SideBar?.style.setProperty('position', 'relative')
}

export function closeSidebar()  {
    const SideBar = document.getElementById("allSidebar") 
    SideBar?.style.setProperty('display', 'none')
}